import React from 'react'
import { Link, useHistory } from 'react-router-dom'

function SideBar() {
  let history = useHistory()

  const logout = () => {
    localStorage.removeItem('token')
    history.push('/login')
  }

  return (
    <div className="sidebar">
      <div className="sidebar-wrapper">
        <div className="logo">
          <Link className="simple-text" to="/admin">
            Rekindle Admin Panel
          </Link>
        </div>
        <ul className="nav">
          <li className="nav-item active">
            <Link className="nav-link" to="/admin/dashboard">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Dashboard</p>
            </Link>
          </li>
          <li className="nav-item active">
            <Link className="nav-link" to="/admin/users">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Users List</p>
            </Link>
          </li>
          <li className="nav-item active">
            <Link className="nav-link" to="/admin/orders">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Transactions</p>
            </Link>
          </li>
          <li className="nav-item active">
            <Link className="nav-link" to="/admin/activities">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Activities</p>
            </Link>
          </li>
          <li className="nav-item active">
            <Link className="nav-link" to="/admin/matches">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Matches</p>
            </Link>
          </li>
          {/* <li className="nav-item active">
            <Link className="nav-link" to="/admin/interests">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>User Interests</p>
            </Link>
          </li> */}
          {/* <li className="nav-item active">
            <Link className="nav-link" to="/admin/referral">
              <i className="nc-icon nc-chart-pie-35"></i>
              <p>Referral list</p>
            </Link>
          </li> */}
          <li className="nav-item active">
            <a className="nav-link" style={{ cursor: "pointer" }} onClick={() => logout()}>
              <i className="nc-icon nc-simple-remove"></i>
              <p>Logout</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export { SideBar }
